import { __assign } from 'tslib';
import { theme } from '@compono/ui-theme-compono';

var createTheme = function (themeOverrides) {
    return __assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), themeOverrides) });
};

export { createTheme };
//# sourceMappingURL=createTheme.js.map
